import { Platform } from 'react-native'

interface ThemeColors {
    textPrimary: string
    textSecondary: string
    colorPrimary: string
    colorSecondary: string
    colorTertiary: string
    colorApprovedEvaluation: string
    colorApproved: string
    colorCancelled: string
    colorPending: string
    colorInProgress: string
    colorLocked: string
    colorSeen: string
    colorRetry: string
    colorDisapproved: string
    error: string
    alert: string
    disabled: string
    background: string
    modalBackground: string
    formsBackground: string
    filtersBackground: string
    linearGradientStart: string
    linearGradientEnd: string
    linearGradientGreenStart: string
    linearGradientGreenEnd: string
    linearGradientRedStart: string
    linearGradientRedEnd: string
    neutralGray: string
    lightGray: string
    mediumGray: string
    darkGray: string
    colorHeart: string
    colorComment: string
    colorShare: string
    gamificationDotApprovedColor: string
    pageIndicatorBackground: string
    RankingFirstPlaceColor: string
    RankingSecondPlaceColor: string
    RankingThirdPlaceColor: string
    RankingPointsColor: string
    createScheduleBackgroundColor: string
    vacationDaySelectedColor: string
    floatPageIndicatorBackground: string
    storeFormButtonBackground: string
    storeItemTextAddressStoreWithGoTo: string
}

interface ThemeFontSizes {
    ultraBigText: number
    bigText: number
    normalText: number
    mediumText: number
    smallText: number
    ultraSmallText: number
}

interface ThemeFonts {
    main: string
}

interface ThemeFontWeights {
    light: string
    normal: string
    bold: string
}

interface ThemeFontStyles {
    normal: string
    italic: string
}

interface Theme {
    colors: ThemeColors
    fontSizes: ThemeFontSizes
    fonts: ThemeFonts
    fontWeights: ThemeFontWeights
    fontStyles: ThemeFontStyles
}

const theme: Theme = {
    colors: {
        textPrimary: '#12122F',
        textSecondary: '#5C5C86',
        colorPrimary: '#0F059E',
        colorSecondary: '#995DD8',
        colorTertiary: '#389CFC',
        colorApprovedEvaluation: '#64CC7B',
        colorApproved: '#009E4D',
        colorCancelled: '#E51D0D',
        colorPending: '#8192C0',
        colorInProgress: '#FFA500',
        colorLocked: '#727293',
        colorSeen: '#995DD8',
        colorRetry: '#E51D0D',
        colorDisapproved: '#E51D0D',
        error: '#E51D0D',
        alert: '#FFDE39',
        disabled: '#DDDBE2',
        background: '#FFFFFF',
        modalBackground: '#E1E6F9',
        formsBackground: '#F9FBFE',
        filtersBackground: '#F9FBFE',
        linearGradientStart: '#995DD8',
        linearGradientEnd: '#0F059E',
        linearGradientGreenStart: '#16823F',
        linearGradientGreenEnd: '#028754',
        linearGradientRedStart: '#C21818',
        linearGradientRedEnd: '#DA2121',
        neutralGray: '#DADADA',
        lightGray: '#D5D7E9',
        mediumGray: '#8192C0',
        darkGray: '#5C5C86',
        colorHeart: '#C500B9',
        colorComment: '#00C8FF',
        colorShare: '#09924E',
        gamificationDotApprovedColor: '#53D06F',
        pageIndicatorBackground: '#FAFAFA',
        RankingFirstPlaceColor: '#E2BA61',
        RankingSecondPlaceColor: '#666666',
        RankingThirdPlaceColor: '#ED713B',
        RankingPointsColor: '#1C98F0',
        createScheduleBackgroundColor: '#E53935',
        vacationDaySelectedColor: '#141319',
        floatPageIndicatorBackground: '#FAFAFA',
        storeFormButtonBackground: '#F1F2FF',
        storeItemTextAddressStoreWithGoTo: '#6D85DA',
    },
    fontSizes: {
        ultraBigText: 18,
        bigText: 16,
        normalText: 15,
        mediumText: 14,
        smallText: 13,
        ultraSmallText: 12,
    },
    fonts: {
        main: Platform.select({
            android: 'System',
            ios: 'System',
            default: 'System',
        }) as string,
    },
    fontWeights: {
        light: '300',
        normal: '400',
        bold: '700',
    },
    fontStyles: {
        normal: 'normal',
        italic: 'italic',
    },
}

export default theme
export type { Theme, ThemeColors, ThemeFontSizes, ThemeFonts, ThemeFontWeights, ThemeFontStyles }
